import { render, staticRenderFns } from "./formulaConfig.vue?vue&type=template&id=4e0efa00&scoped=true&"
import script from "./formulaConfig.vue?vue&type=script&lang=js&"
export * from "./formulaConfig.vue?vue&type=script&lang=js&"
import style0 from "./formulaConfig.vue?vue&type=style&index=0&id=4e0efa00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0efa00",
  null
  
)

export default component.exports